(function () {
  'use strict';
  var S = window.SITRA || {};
  var U = S.u;
  var $ = U.$, $$ = U.$$, money = U.money, lockScroll = U.lockScroll, store = U.store, esc = U.esc, addToCart = U.addToCart, renderCart = U.renderCart, cartFetch = U.cartFetch, shipProgress = U.shipProgress, wishInit = U.wishInit;

  /* ---------- collection filters ---------- */
  function initCollection(root) {
    var sectionId = root.dataset.sectionId;
    function load(url, push, append) {
      var res = $('[data-results]', root); res.classList.add('is-loading');
      var u = new URL(url, window.location.origin); u.searchParams.set('section_id', sectionId);
      return fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        if (append) {
          var grid = $('[data-grid]', root), ng = d.querySelector('[data-grid]');
          if (grid && ng) Array.prototype.slice.call(ng.children).forEach(function (ch) { grid.appendChild(ch); });
          ['[data-loadmore]'].forEach(function (s) { var a = $(s, root), b = d.querySelector(s); if (a && b) a.replaceWith(b); else if (a && !b) a.remove(); });
        } else {
          ['[data-results]', '[data-facets-body]', '[data-count]', '[data-active-count]'].forEach(function (s) { var a = $(s, root), b = d.querySelector(s); if (a && b) a.innerHTML = b.innerHTML; });
        }
        res.classList.remove('is-loading'); wishInit(root);
        if (push) { u.searchParams.delete('section_id'); window.history.pushState({}, '', u.toString()); }
      });
    }
    function formUrl() {
      var form = $('[data-facets-form]', root); var fd = new FormData(form); var p = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var sort = $('[data-sort]', root); if (sort && sort.value) p.set('sort_by', sort.value);
      return window.location.pathname + '?' + p.toString();
    }
    var deb;
    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-facets-form]') || e.target.matches('[data-sort]')) { clearTimeout(deb); deb = setTimeout(function () { load(formUrl(), true); }, e.target.type === 'number' ? 600 : 50); }
    });
    root.addEventListener('submit', function (e) { if (e.target.closest('[data-facets-form]')) { e.preventDefault(); load(formUrl(), true); } });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove-filter]'); if (rm) { e.preventDefault(); load(rm.getAttribute('href'), true); return; }
      var lm = e.target.closest('[data-loadmore-btn]'); if (lm) { e.preventDefault(); lm.disabled = true; load(lm.dataset.next, false, true); return; }
      var ft = e.target.closest('[data-facets-toggle]');
      if (ft) { if (window.matchMedia('(max-width:760px)').matches) { $('.facets', root).classList.add('is-open'); lockScroll(true); } else { var lay = $('.clayout', root); lay.classList.toggle('facets-hidden'); ft.setAttribute('aria-expanded', lay.classList.contains('facets-hidden') ? 'false' : 'true'); $('[data-facets-label]', ft).textContent = lay.classList.contains('facets-hidden') ? 'Show filters' : 'Hide filters'; } return; }
      if (e.target.closest('[data-facets-close]')) { $('.facets', root).classList.remove('is-open'); lockScroll(false); return; }
      var dn = e.target.closest('[data-dens]');
      if (dn) { $$('[data-dens]', root).forEach(function (b) { b.setAttribute('aria-pressed', b === dn ? 'true' : 'false'); }); root.style.setProperty('--cols', dn.dataset.dens); store('sitra-dens', dn.dataset.dens); }
    });
    var dens = store('sitra-dens'); if (dens) { root.style.setProperty('--cols', dens); $$('[data-dens]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.dens === dens ? 'true' : 'false'); }); }
    window.addEventListener('popstate', function () { load(window.location.href, false); });
  }

  function bootCollection() { $$('[data-collection]').forEach(initCollection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootCollection); else bootCollection();
  document.addEventListener('shopify:section:load', bootCollection);
})();